export default __webpack_public_path__ + "static/media/darkmode-editAccount.30099503.svg";